export class GameOverState {
	public stateController;
	public stateObject;
	public rouletteController;
	public menuButton;
	public rulesButton;
	public spinButton;
	public undoButton;
	public deleteButton;
	public infoButton;
	public guiController;

	constructor(scene, stateController) {
		this.stateController = stateController;
		this.stateObject = scene;
		this.rouletteController = scene.rouletteController;
		this.spinButton = this.rouletteController.slotSpinButton;
		this.guiController;
	}

	enterFrom(oldState) {
		console.log(this.toString() + ' - Enter From: ' + oldState.toString());
		this.rouletteController.setControlActivity(false);
		if (this.stateObject.rouletteBalanceValue === 0) {
			var mess = this.stateObject.guiController.showShare('Share', 'Game over.', this, () => {
				this.stateObject.guiController.closePopUp(mess);
			});
			this.stateController.changeState(this.stateObject.iddleState);
			return;
		}
	}

	exitTo(newState) {
		console.log(this.toString() + ' - Exit To: ' + newState.toString());
	}

	toString() {
		return 'GameOverState';
	}
}
